// interface Props {
//   chartsRef: React.MutableRefObject<ChartsImperativeRef | null>;
//   onShowConfigurationDetailsModal(): void;
// }

import { FilterBreakdownBar } from "./filter-breakdown-bar";
import { FilterBreakdownLabelBar } from "./filter-breakdown-label-bar";
import { SavedViewBar, type SavedViewBarProps } from "./saved-view-bar";

export const TopLevelFilters = (props: SavedViewBarProps) => {
  return (
    <>
      <SavedViewBar {...props} />
      <FilterBreakdownLabelBar />
      <FilterBreakdownBar />
    </>
  );
};
